import { useTranslation } from "react-i18next";

import { FormRenderer, type RenderSchema } from "../../../components/forms/FormRenderer";
import { normalizeLang } from "../../../lib/apiErrorMessage";
import { useFormResponse } from "../../../lib/queries/formResponses";

/** Read the attached response's exact version, independently of current catalogue eligibility. */
export function AttachedSpecIdentity({
  responseId,
  projectId,
}: {
  responseId: string;
  projectId?: string;
}) {
  const { t, i18n } = useTranslation();
  const q = useFormResponse(responseId);
  if (q.isPending) return <p role="status">{t("attached_spec.loading")}</p>;
  const d = q.data;
  if (
    q.isError ||
    !d ||
    d.response.id !== responseId ||
    !projectId ||
    d.response.project_id !== projectId ||
    d.version.id !== d.response.template_version_id
  ) {
    return <p role="status">{t("attached_spec.unavailable")}</p>;
  }
  return (
    <div className="min-w-0 space-y-2">
      <p className="break-words font-medium text-slate-900">{d.template.name}</p>
      <p className="text-sm tabular-nums text-slate-600">
        {t("attached_spec.version", { number: d.version.version_number })}
      </p>
      <details className="rounded-lg border border-slate-200 p-3">
        <summary className="focus-visible:ring-brand-500 text-brand-700 min-h-11 cursor-pointer rounded text-sm font-medium focus-visible:outline-none focus-visible:ring-2">
          {t("attached_spec.review")}
        </summary>
        <p className="my-3 text-sm text-slate-600">{t("attached_spec.readonly")}</p>
        <FormRenderer
          schema={d.version.schema as RenderSchema}
          locale={normalizeLang(i18n.resolvedLanguage)}
          mode="readonly"
          values={d.response.data}
        />
      </details>
    </div>
  );
}
